/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Organizer_Guide_TitleInputs */



/**
* | output |
* | --- |
* | "Organizer Guide" |
*
* @param {Help_Organizer_Guide_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_organizer_guide_title = /** @type {((inputs?: Help_Organizer_Guide_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Organizer_Guide_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Guide de l'organisateur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guía del organizador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Guia do Organizador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guida dell'Organizzatore")
	return /** @type {LocalizedString} */ ("Organizer Guide")
});